import * as types from '../constants/officeRunnerConstants'

export default function busy(state = false, action) {
  switch (action.type) {
    case types.CREATE_LEAD_REQUEST:
    case types.FETCH_POSITIONS_REQUEST:
    case types.GEOCODE_REQUEST:
    case types.REQUEST_STATE_INFO:
      return true
    case types.CREATE_LEAD_FAILURE:
    case types.CREATE_LEAD_SUCCESS:
    case types.FETCH_POSITIONS_FAILURE:
    case types.FETCH_POSITIONS_SUCCESS:
    case types.GEOCODE_FAILURE:
    case types.GEOCODE_SUCCESS:
    case types.RECEIVE_STATE_INFO:
      return false
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/busyReducer.js